module.exports = __webpack_public_path__ + "static/media/car-warning.1fb14266.svg";